import React from 'react'

import { CommonClose2Icon } from '@web/../assets/icons'

import ModalContainer from '@web/components/Modal/ModalContainer'
import { ModalComponent } from '@web/components/Modal/types'
import { LineAppNotification } from '@web/gql/graphql'

import Clickable from '../Clickable'
import styles from './EventPopupContainer.module.scss'

interface ContentProps {
  event?: LineAppNotification
}

export const EventPopupContainer: ModalComponent<ContentProps> = ({ showModal, cancelModal, event }) => {
  if (!event) return null

  const clickCode = `lan.${event?.exposureArea?.replace(/_/g, '')}`

  return (
    <ModalContainer showModal={showModal} className={styles.modal_event}>
      <div
        className={styles.img_area}
        style={{
          background: `url(${event.contentUrl}) no-repeat 50% 0`,
          backgroundSize: '295px 390px',
        }}
      >
        <span className="place_blind">
          {event.title} {event.description}
        </span>
        <Clickable
          className={styles.btn_link}
          nClickCode={clickCode}
          nClickCid={event.id}
          onClick={e => {
            cancelModal(e)
            if (event.linkUrl) window.location.href = event.linkUrl
          }}
        >
          <span className="place_blind">자세히보기</span>
        </Clickable>
      </div>
      <Clickable
        className={styles.btn_close}
        nClickCode={`lan.${clickCode}close`}
        nClickCid={event.id}
        onClick={cancelModal}
      >
        <CommonClose2Icon className={styles.icon} aria-hidden="true" />
        <span className="place_blind">닫기</span>
      </Clickable>
    </ModalContainer>
  )
}
